import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarColor'
})
export class AvatarColorPipe implements PipeTransform {

  transform(value: string): string {
    if (value && value.length >= 2) {
      const letter1 = value.charAt(0).toUpperCase();
      const letter2 = value.charAt(1).toUpperCase();
      const red = this.generateValue(letter1);
      const green = this.generateValue(letter2);
      const blue = this.generateValue(letter1 + letter2);
      if (red === 255 && green === 255 && blue === 255) {
        return `rgb(${red - 1}, ${green - 1}, ${blue - 1})`;
      } else {
        return `rgb(${red}, ${green}, ${blue})`;
      }
    } else {
      return '';
    }
  }

  private generateValue(str: string): number {
    const hash = this.hashCode(str);
    return Math.floor((hash % 128) + 64);
  }

  private hashCode(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

}
